import { type CSSProperties } from "react";

/**
 * Base layout and typography for the filled chrome itinerary price pill.
 */
export const ITINERARY_PRICE_PILL_CHROME_BASE_CLASSNAME =
    "inline-flex shrink-0 items-center justify-center whitespace-nowrap rounded-2xl px-2.5 py-1 text-xs font-extrabold tracking-tight shadow-sm";

/**
 * Filled green chrome pill for a resolved itinerary price.
 */
export const ITINERARY_PRICE_PILL_CHROME_FILLED_CLASSNAME =
    `${ ITINERARY_PRICE_PILL_CHROME_BASE_CLASSNAME } bg-green-price text-white shadow-green-price/30`;

/**
 * Outlined chrome layout for the personal-car (I take my car) price pill.
 * Border and text colors come from {@link buildItineraryPricePillChromeOutlineStyle}.
 */
export const ITINERARY_PRICE_PILL_CHROME_OUTLINE_MY_CAR_CLASSNAME =
    `${ ITINERARY_PRICE_PILL_CHROME_BASE_CLASSNAME } border-2 border-solid`;

/**
 * Inline styles for a themed outline chrome pill (border + text).
 *
 * @param accentColor Theme accent for border and label text.
 * @returns Style object applied to the pill container.
 */
export const buildItineraryPricePillChromeOutlineStyle = ( accentColor: string ): CSSProperties => ( {
    "borderColor": accentColor,
    "color":       accentColor,
} );

/**
 * Inline styles for the chrome pill while offer or list pricing is loading.
 *
 * @param loadingAccentColor Theme accent for spinner and label text.
 * @returns Style object applied to the pill container.
 */
export const buildItineraryPricePillChromeLoadingStyle = ( loadingAccentColor: string ): CSSProperties => ( {
    "background": `${ loadingAccentColor }18`,
    "boxShadow":  `0 2px 10px ${ loadingAccentColor }22`,
    "color":      loadingAccentColor,
} );
